export type Market = "DK" | "INTL" | "SE";

export const PRICE_TABLE = {
  DK: {
    websitesSetup: 5000, // DKK
    websitesSubscription: 400,
    bookingSetup: 5000,
    bookingSubscription: 800,
    webshopSetup: 15000,
    webshopSubscription: 1500,
    mobileAppSetup: 50000,
    mobileAppSubscription: 1500,
    customHourly: 650,
  },
  INTL: {
    websitesSetup: 775, // USD
    websitesSubscription: 60,
    bookingSetup: 775,
    bookingSubscription: 125,
    webshopSetup: 2300,
    webshopSubscription: 230,
    mobileAppSetup: 7900,
    mobileAppSubscription: 230,
    customHourly: 100,
  },
  SE: {
    websitesSetup: 7000, // SEK
    websitesSubscription: 600,
    bookingSetup: 7000,
    bookingSubscription: 1100,
    webshopSetup: 22000,
    webshopSubscription: 2200,
    mobileAppSetup: 72000,
    mobileAppSubscription: 2200,
    customHourly: 950,
  },
} as const;

export const CURRENCY_BY_MARKET = {
  DK: { code: "DKK", locale: "da-DK" },
  INTL: { code: "USD", locale: "en-IE" }, // or "en-DE" etc.
  SE: { code: "SEK", locale: "sv-SE" },
} as const;
